import React from "react";
import LinkNoStyle from "../../../../components/common/LinkNoStyle/LinkNoStyle";
import { getImagePath } from "../../../../utils/images";
import * as styles from "./PromoCardNavigation.module.scss";
export const PromoCardNavigation: React.FC<DogsTrust.SignPostCardProps> = ({
	title,
	body,
	imgAlt,
	imgSrc,
	buttonUrl,
	tabIndex,
	tabTo,
}) => {
	return (
		<article className={styles.promocardnav}>
			<LinkNoStyle
				className={styles.cardlink}
				to={buttonUrl}
				tabIndex={tabIndex}
				onKeyDown={(e) => {
					if (e.key === "Tab" && tabTo) {
						e.preventDefault();
						document.getElementById(tabTo)?.focus();
					}
				}}
			>
				<div
					className={styles.imagebackground}
					style={{
						backgroundImage: `url(${getImagePath("400x300", imgSrc)})`,
					}}
					aria-label={imgAlt}
				/>
				<div className={styles.imagebackgroundoverlay} />
				<div className={styles.pretitle}>{title}</div>
				<div className={styles.title}>{body}</div>
			</LinkNoStyle>
		</article>
	);
};
